const stripHtml = (html: string): string =>
  html.replace(/<[^>]*>/g, ' ').replace(/\s+/g, ' ').trim();

const truncateText = (text: string, maxLength: number): string => {
  if (text.length <= maxLength) return text;
  return `${text.slice(0, maxLength - 3).trim()}...`;
};

/** Mensagem padrão ao contatar proprietário pelo WhatsApp via LiveStay. */
export const buildPropertyWhatsAppMessage = (
  propertyTitle: string,
  propertyDescription?: string | null,
): string => {
  const title = propertyTitle.trim() || 'Imóvel';
  const rawDescription = propertyDescription
    ? stripHtml(propertyDescription)
    : '';
  const description = rawDescription
    ? truncateText(rawDescription, 400)
    : '';

  const lines = [
    'Olá! Estou entrando em contato pela plataforma LiveStay.',
    '',
    `Tenho interesse no imóvel: ${title}.`,
  ];

  if (description) {
    lines.push('', description);
  }

  return lines.join('\n');
};

/** Monta URL wa.me / WhatsApp Web a partir de telefone, DDI e mensagem opcional. */
export const buildWhatsAppUrl = (
  phone: string,
  ddi = '55',
  message?: string,
): string => {
  const phoneDigits = phone.replace(/\D/g, '');
  if (!phoneDigits) return 'https://wa.me/';

  const ddiDigits = (ddi || '55').replace(/\D/g, '') || '55';
  const fullNumber = phoneDigits.startsWith(ddiDigits)
    ? phoneDigits
    : `${ddiDigits}${phoneDigits}`;

  const baseUrl = `https://wa.me/${fullNumber}`;
  if (!message?.trim()) return baseUrl;

  return `${baseUrl}?text=${encodeURIComponent(message.trim())}`;
};
